import React from 'react';

import {
  CommentaireRequestDto,
  CommentaireResponseDto,
  CommentaireViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseTextArea from 'components/BaseForm/BaseTextArea';
import { useUserStore } from 'hooks/UserStoreContext';
import { CSSUtils } from 'utils/CSSUtils';

import { UserIcon } from '../UserIcon/UserIcon';

import { useSubmitCommentaire, useValidateCommentaireField } from './utils';

import './CommentaireForm.less';

interface CommentaireFormProps {
  dossierId: string;
  commentaire?: CommentaireResponseDto;
  onClose: () => void;
}

export const CommentaireForm: React.FC<CommentaireFormProps> = ({
  dossierId,
  commentaire,
  onClose,
}: CommentaireFormProps): React.ReactElement => {
  const user = useUserStore();

  const { submit, inProgress } = useSubmitCommentaire(
    dossierId,
    onClose,
    commentaire,
  );

  const validateField = useValidateCommentaireField(dossierId, commentaire);

  const initialValues: CommentaireRequestDto = {
    contenu: commentaire?.contenu ?? '',
  };

  return (
    <div className="ajoutCommentaireForm">
      <UserIcon
        firstName={user.firstName ?? ''}
        lastName={user.lastName ?? ''}
        profile={user.profile}
      />
      <div className="ajoutCommentaireForm__form">
        <BaseForm
          initialValues={initialValues}
          validateField={validateField}
          isSubmitting={inProgress}
          onSubmit={submit}
          onCancel={onClose}
          inputs={[
            {
              field: CommentaireViolationDtoFormFieldEnum.CONTENU,
              name: 'contenu',
              wrapperCol: { span: CSSUtils.fullWidthCol },
              render: () => <BaseTextArea autoFocus autoSize />,
            },
          ]}
          renderButtonAction={(Submit, Cancel) => {
            return (
              <div className="ajoutCommentaireForm__form__btns">
                <div>{Submit}</div>
                <div>{Cancel}</div>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};
